'use client';
import Script from 'next/script';

const AboutSchema = () => {
    return (
        <Script
            id="about-schema"
            type="application/ld+json"
            dangerouslySetInnerHTML={{
                __html: JSON.stringify({
                    '@context': 'https://schema.org',
                    '@type': 'Organization',
                    name: '加密城市 CryptoCity',
                    url: 'https://www.cryptocity.tw/',
                    logo: 'https://cdn.cryptocity.tw/assets/images/logo.png',
                    description:
                        '加密城市 CryptoCity，關心您在乎的幣圈大小事。我們是最全面的區塊鏈資訊平台，專注於Web3、AI 等領域，每日提供業界新聞和最實用的資訊，以促進區塊鏈產業的發展。',
                    sameAs: [
                        'https://www.facebook.com/CryptoCitytw',
                        'https://x.com/CryptoCitytw',
                        'https://www.instagram.com/cryptocitytw/',
                        'https://tw.linkedin.com/company/cryptocity',
                    ],
                    contactPoint: {
                        '@type': 'ContactPoint',
                        telephone: '02-29506580',
                        contactType: 'Customer Service',
                        areaServed: 'TW',
                        availableLanguage: 'Chinese',
                    },
                }),
            }}
        ></Script>
    );
};

export default AboutSchema;
